/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Foxit_TypeInputs */

const en_pc_alt_t_foxit_type = /** @type {(inputs: Pc_Alt_T_Foxit_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commercial PDF editor`)
};

const zh_pc_alt_t_foxit_type = /** @type {(inputs: Pc_Alt_T_Foxit_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商业 PDF 编辑器`)
};

/**
* | output |
* | --- |
* | "Commercial PDF editor" |
*
* @param {Pc_Alt_T_Foxit_TypeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_foxit_type = /** @type {((inputs?: Pc_Alt_T_Foxit_TypeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Foxit_TypeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_foxit_type(inputs)
	return zh_pc_alt_t_foxit_type(inputs)
});
export { pc_alt_t_foxit_type as "pc.alt.t.foxit.type" }